export const EMAIL_OTP_TIMEOUT = 40;
export const PASSWORD_SETTED_REDIRECT_TIMEOUT = 3;
